import { useMultiStyleConfig, useRadio } from '@chakra-ui/react';
import Box from '../Box/Box';
import { useSegmentedControlContext } from './SegmentedControl.context';

export interface SegmentedControlItemProps {
  children: string;
  isDisabled?: boolean;
  value: string;
}

const SegmentedControlItem = (props: SegmentedControlItemProps) => {
  const { getRadioProps, isGroupDisabled } = useSegmentedControlContext();

  const { children, isDisabled, value } = props;

  const { getInputProps, getRadioProps: getChakraRadioProps } = useRadio({
    ...getRadioProps({ value }),
    isDisabled: isGroupDisabled || isDisabled,
  });

  const theme = useMultiStyleConfig('SegmentedControl');

  const radioProps = getChakraRadioProps();
  delete radioProps['aria-hidden'];

  return (
    <Box __css={theme.item} as="label" {...radioProps}>
      <input {...getInputProps()} />
      {children}
    </Box>
  );
};

export default SegmentedControlItem;
